import React, {Component} from 'react';
import {connect} from 'react-redux';
import {selectCategory} from "../../actionCreators";
import iconAll from './../../img/general/icon-all.png';

class ShopCategory extends Component {
  constructor(props) {
    super(props);
    this.state = {
      idProductActive: 'all'
    };
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    const {selectCategory, categories, isRenderingProducts} = this.props;
    //have categories - show first category
    if (categories && categories.length !== 0) {
      // let firstProduct = categories[0].id;
      // setTimeout(function(){
      if (!isRenderingProducts) selectCategory('all');
      // }, 1000)
    }
  }

  handleSelectCategory = (e) => {
    const {selectCategory} = this.props;
    let idCategory = e.currentTarget.dataset.id;
    this.setState({
      idProductActive: idCategory
    });
    selectCategory(idCategory);
  };

  renderCategoriesList = () => {
    const {handleSelectCategory} = this;
    const {categories, loadedCat} = this.props;
    const {idProductActive} = this.state;

    if (!loadedCat) return <div className="loading-b">loading...</div>;
    if (!categories || !categories.length) { return <div className="loading-b">No categories</div>; }
    const categoriesElements = categories.map(categoriesItem => (
      <li key={categoriesItem.id} data-id={categoriesItem.id} className={`shop-category__item ${ +idProductActive === categoriesItem.id ? ' shop-category__item--active' : '' } `} onClick={handleSelectCategory}>
        <button className="shop-category__button" type="button">
          <div className="shop-category__img">
            <img src={categoriesItem.icon} alt={categoriesItem.name} />
          </div>
          <div className="shop-category__title">{categoriesItem.name}</div>
        </button>
      </li>
    ));
    return (
      <ul className="shop-category__list">
        <li key={"all"} data-id={"all"} className={`shop-category__item ${ idProductActive === 'all' ? ' shop-category__item--active' : '' }`} onClick={handleSelectCategory}>
          <button className="shop-category__button" type="button">
            <div className="shop-category__img">
              <img src={iconAll} className="shop-category__img--img" alt="all categories" />
            </div>
            <div className="shop-category__title">Alle</div>
          </button>
        </li>
        {categoriesElements}
      </ul>
    )
  };

  render() {
    const {renderCategoriesList} = this;
    const {cart} = this.props;
    return (
      <section className="shop-category">
        <div className="container">
          <div className="shop-category__wrap">
            <h2>{cart.length !== 0 ? ('Möchten Sie weitere Möbel hinzufügen?') : ('suchen Sie die Kategorie aus:')}</h2>
            { renderCategoriesList() }
          </div>
        </div>
      </section>
    );
  }
}

export default connect((state) => {
  return {
    isRenderingProducts: state.categories.isRenderingProducts,
    categories: state.categories.categoriesList,
    loadingCat: state.categories.loading,
    loadedCat: state.categories.loaded,
    renderProductsList: state.categories.renderProductsList,
    cart: state.cart,
  }
}, {selectCategory})(ShopCategory);


// WEBPACK FOOTER //
// ./src/components/Shop/ShopCategory.js